import '../../../css/indent.css';

export default function Total({indent}){

    const amount = indent.items.map(i => i.price * i.quantity).reduce((a,b) => a + b, 0);

    const tax = indent.items.map(i => i.price * i.quantity * i.taxRate).reduce((a,b) => a + b, 0);

    const taxedAmount = amount + tax;

    return <div className="total">

        <span className="total-title">Total</span>

        <span className="total-amount">{taxedAmount.toLocaleString()}€</span>
        
    </div>
}